import { Box, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';

import { UnrecognizedPayment } from '../types';
import { formatAmount } from '../utils/money';

export const UnrecognizedPayments = ({ payments }: { payments: UnrecognizedPayment[] }) => {
  if (!payments.length) return null;
  return (
    <Box mt={4} overflowX="auto">
      <Text fontWeight="semibold" mb={2}>
        Nierozpoznane wpłaty
      </Text>
      <Table size="sm">
        <Thead>
          <Tr>
            <Th>Data</Th>
            <Th>Rachunek i opis</Th>
            <Th>Przyczyna</Th>
            <Th isNumeric>Kwota</Th>
          </Tr>
        </Thead>
        <Tbody>
          {payments.map((payment, index) => (
            <Tr key={index}>
              <Td whiteSpace="nowrap">{new Date(payment.date).toLocaleDateString('pl-PL')}</Td>
              <Td minWidth="180px" maxWidth="400px" overflowWrap="anywhere">
                <Text>{payment.identifier || 'Brak rachunku'}</Text>
                <Text fontSize="xs">{payment.description}</Text>
              </Td>
              <Td>{payment.reason}</Td>
              <Td isNumeric whiteSpace="nowrap">
                {formatAmount(payment.amount, payment.currency)}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};
